import { GenerateIncentiveOfferPurchaseContractModalContextType } from '../types/GenerateIncentiveOfferPurchaseContractModalContextType';

export const generateIncentiveOfferPurchaseContractModalInitValue: GenerateIncentiveOfferPurchaseContractModalContextType =
  {
    data: {
      isLoading: false,
      templateId: '',
      societyId: '',
      operationId: '',
    },
    actions: {
      handleSave: async () => {},
      handleCloseModal: () => {},
    },
  };
